import type { StoreChatItem } from '@atlassian/conversation-assistant-store/controllers/chat/types';
import { getAdminhubPolicyPreviewClientId } from '@atlassian/rovo-content-bridge-api-commands/clients/adminhub-policy-preview-client';
import type { ReadContentCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/read-content-command';

import { getLatestPolicyPreviewContentId } from './getLatestPolicyPreviewContentId';

export const getPolicyPreviewReceiverId = (
	conversationId: string,
	messages: StoreChatItem[],
): ReadContentCommandProperties['receiverId'] | undefined => {
	const contentId = getLatestPolicyPreviewContentId(messages);
	return contentId !== undefined
		? getAdminhubPolicyPreviewClientId(conversationId, contentId)
		: undefined;
};
